import PropTypes from 'prop-types'
import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import CommentEdit from '../CommentEdit/index'
import TextSeasonEpisode from '../TextSeasonEpisode/index'
import { formatSeriesHost } from '../../theme/web-app/index'
import { H5, H6, HEADING_TYPES } from '../Heading/index'
import { isEpisode } from '../../services/content/index'

function getIsSeries (data) {
  const product = data.getIn(['type', 'product'])
  return product === 'episode' || product === 'segment'
}

function renderHeaderText (props) {
  const { data } = props
  const contentType = data.get('contentType')
  const title = data.get('title')
  const isSeriesLikeContent = getIsSeries(data) || isEpisode({ contentType, data })

  // series-like
  if (isSeriesLikeContent) {
    const seriesTitle = data.get('seriesTitle')
    const episode = data.get('episode') || data.get('episodeNumber')
    const season = data.get('season') || data.get('seasonNumber')
    const host = data.get('host') || data.get('instructor')
    if (episode && season) {
      return (
        <div>
          <H5 as={HEADING_TYPES.H6} className="comments-header__title">{title}</H5>
          <div className="comments-header__series-title">
            {formatSeriesHost(seriesTitle, host)}
          </div>
          <TextSeasonEpisode
            className={['comments-header__text-season-episode']}
            episode={episode}
            season={season}
          />
        </div>
      )
    }
    return (
      <div>
        <H5 as={HEADING_TYPES.H6} className="comments-header__title">{title}</H5>
        <div className="comments-header__series-title">
          {formatSeriesHost(seriesTitle, host)}
        </div>
      </div>
    )
  }
  return <H6 className="comments-header__title">{title}</H6>
}

function CommentsHeader (props) {
  const {
    auth, data, location, createComment, updateComment,
  } = props
  if (!data) {
    return (
      <header className="comments-header">
        <H6 className="comments-header__title">
          {props.commentsHeaderStaticText.getIn(['data', 'comments'])}
        </H6>
      </header>
    )
  }
  return (
    <header className="comments-header">
      {renderHeaderText(props)}
      <CommentEdit
        auth={auth}
        data={data}
        showAvatar={true}
        location={location}
        createComment={createComment}
        updateComment={updateComment}
        isHeaderComment
      />
    </header>
  )
}

CommentsHeader.propTypes = {
  data: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  createComment: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
  commentsHeaderStaticText: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object,
}

export default connect((state) => ({
  commentsHeaderStaticText: state.staticText.getIn(
    ['data', 'commentsHeader'],
    Map(),
  ),
}))(CommentsHeader)
